import React from "react";
import { Box } from "@mui/material";

const DefaultLayout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        maxWidth: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default DefaultLayout;
